/**
 * A Google Maps search URL for a Standort's address, as the legacy site links
 * it (`google.com/maps/search/…`). `name` leads the query so Maps lands on the
 * Standort itself rather than on a bare street address.
 */
export function locationMapsUrl({
  name,
  street,
  zipCode,
  cityName,
}: {
  name: string;
  street: string;
  zipCode: string;
  cityName: string;
}): string {
  const query = encodeURIComponent(
    `${name}, ${street}, ${zipCode} ${cityName}`,
  );
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}
